/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: StringTools
 * root Object
 * @constructor
 */
window.StringTools = function() {};
$hxClasses['StringTools'] = StringTools;
/** @private @type {Array} */
StringTools.__name__ = ["StringTools"];

/**
 * urlEncode
 * Encode an URL by using the standard format.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {string}
 */
StringTools.urlEncode = function(s) {
	return encodeURIComponent(s);
};


/**
 * urlDecode
 * Decode an URL using the standard format.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {string}
 */
StringTools.urlDecode = function(s) {
	return decodeURIComponent(s.split("+").join(" "));
};


/**
 * htmlEscape
 * Escape HTML special characters of the string.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {string}
 */
StringTools.htmlEscape = function(s) {
	return s.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;");
};


/**
 * htmlUnescape
 * Unescape HTML special characters of the string.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {string}
 */
StringTools.htmlUnescape = function(s) {
    return s.split("&gt;").join(">").split("&lt;").join("<").split("&quot;").join("\"").split("&amp;").join("&");
};


/**
 * startsWith
 * Tells if the string [s] starts with the string [start].
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => start, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {string}  s 
 * @param {string}  start 
 * @return {boolean}
 */
StringTools.startsWith = function(s,start) {
	return s.length >= start.length && HxOverrides.substr(s,0,start.length) == start;
};


/**
 * endsWith
 * Tells if the string [s] ends with the string [end].
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => end, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {string}  s 
 * @param {string}  end 
 * @return {boolean}
 */
StringTools.endsWith = function(s,end) {
	/** @type {number} */ 
	var elen = end.length;
	/** @type {number} */ 
	var slen = s.length;
	return slen >= elen && HxOverrides.substr(s,slen - elen,elen) == end;
};


/**
 * isSpace
 * Tells if the character in the string [s] at position [pos] is a space.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => pos, t => TInst(Int,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {string}  s 
 * @param {number}  pos 
 * @return {boolean}
 */
StringTools.isSpace = function(s,pos) {
	/** @type {number} */ 
	var c = HxOverrides.cca(s,pos);
	return c >= 9 && c <= 13 || c == 32;
};


/**
 * ltrim
 * Removes spaces at the left of the String [s].
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {string}
 */
StringTools.ltrim = function(s) {
	if (typeof(s) != "string") {
		return s;
	}
	/** @type {number} */ 
	var l = s.length;
	/** @type {number} */ 
	var r = 0;
	while(r < l && StringTools.isSpace(s,r)) r++;
	if(r > 0) return HxOverrides.substr(s,r,l - r); else return s;
};


/**
 * rtrim
 * Removes spaces at the right of the String [s].
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {string}
 */
StringTools.rtrim = function(s) {
	if (typeof(s) != "string") {
		return s;
	}
	/** @type {number} */ 
	var l = s.length;
	/** @type {number} */ 
	var r = 0;
	while(r < l && StringTools.isSpace(s,l - r - 1)) r++;
	if(r > 0) return HxOverrides.substr(s,0,l - r); else return s;
};


/**
 * trim
 * Removes spaces at the beginning and the end of the String [s].
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {string}
 */
StringTools.trim = function(s) {
	return StringTools.ltrim(StringTools.rtrim(s));
};


/**
 * rpad
 * Pad the string [s] by appending [c] at its right until it reach [l] characters.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => c, t => TInst(String,[]), opt => false },{ name => l, t => TInst(Int,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @param {string}  c 
 * @param {number}  l 
 * @return {string}
 */
StringTools.rpad = function(s,c,l) {
	/** @type {number} */ 
	var sl = s.length;
	/** @type {number} */ 
	var cl = c.length;
	while(sl < l) if(l - sl < cl) {
		s += HxOverrides.substr(c,0,l - sl);
		sl = l;
	} else {
		s += c;
		sl += cl;
	}
	return s;
};


/**
 * lpad
 * Pad the string [s] by appending [c] at its left until it reach [l] characters.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => c, t => TInst(String,[]), opt => false },{ name => l, t => TInst(Int,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @param {string}  c 
 * @param {number}  l 
 * @return {string}
 */
StringTools.lpad = function(s,c,l) {
	/** @type {string} */ 
	var ns = "";
	/** @type {number} */ 
	var sl = s.length;
	if(sl >= l) return s;

	/** @type {number} */ 
	var cl = c.length;
	while(sl < l) if(l - sl < cl) {
		ns += HxOverrides.substr(c,0,l - sl);
		sl = l;
	} else {
		ns += c;
		sl += cl;
	}
	return ns + s;
};


/**
 * replace
 * Replace all occurences of the string [sub] in the string [s] by the string [by].
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => sub, t => TInst(String,[]), opt => false },{ name => by, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {string}  s 
 * @param {string}  sub 
 * @param {string}  by 
 * @return {string}
 */
StringTools.replace = function(s,sub,by) {
	return s.split(sub).join(by);
};


/**
 * hex
 * Encode a number into a hexadecimal representation, with an optional number of zeros for left padding.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => n, t => TInst(Int,[]), opt => false },{ name => digits, t => TInst(Int,[]), opt => true }],TInst(String,[]))
 * public static function hex( n : Int, ?digits : Int )
 * @public
 * @static
 * @param {number}  n 
 * @param {number}  digits 
 * @return {string}
 */
StringTools.hex = function(n,digits) {
	/** @type {string} */ 
	var s = "";
	/** @type {string} */ 
	var hexChars = "0123456789ABCDEF";
	do {
		s = hexChars.charAt(n & 15) + s;
		n >>>= 4;
	} while(n > 0);
	if(digits != null) while(s.length < digits) s = "0" + s;
	return s;
};


/**
 * fastCodeAt
 * Provides a fast native string charCodeAt access. Since the EOF value might vary depending on the platforms, always test with StringTools.isEOF.
 * Only guaranteed to work if index in [0,s.length] range. Might not work with strings containing \0 char.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => index, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * @public
 * @static
 * @param {string}  s 
 * @param {number}  index 
 * @return {number}
 */
StringTools.fastCodeAt = function(s,index) {
	return s.charCodeAt(index);
};


/**
 * isEOF
 * Only to use together with fastCodeAt.
 *
 * $type TFun([{ name => c, t => TInst(Int,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {number}  c 
 * @return {boolean}
 */
StringTools.isEOF = function(c) {
	return c != c;
};

/** @type {StringTools} */
StringTools.prototype.__class__ = StringTools;
